import { minutesToMilliseconds } from "date-fns";

import { GetReviewCycleLogsParams, getReviewCycleLogs } from "../../services/defs/internal-api/review-cycle-logs";

export const reviewCycleLogsQuery = ({
	resourceTypes,
	resourceIds,
	changeTypes,
	subjectIds,
	limit,
	skip,
	sort,
}: GetReviewCycleLogsParams) => ({
	queryKey: [
		"get-review-cycle-logs-by-query",
		{ resourceTypes, resourceIds, changeTypes, subjectIds, limit, skip, sort },
	],
	queryFn: () => getReviewCycleLogs({ resourceTypes, resourceIds, changeTypes, subjectIds, limit, skip, sort }),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting review cycle logs.",
	},
});
